/**
 * invitations.js
 *
 * Defines constants for different invitation types used in the application.
 * Used for filtering or labeling invitation-related data.
 */

export const HANDS_ON_LAB = 'Hands on Lab'; // Hands-on lab invitation
export const CAPTURE_THE_FLAG = 'Capture the Flag'; // Capture the Flag invitation
export const GET_IT_GIRL = 'Get it Girl'; // Get it Girl invitation
export const VIC_ONE = 'VicOne'; // VicOne invitation
